import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  open: false,
  type: 'required',
  message: [],
  callback: undefined
}

const RootMessageAlertSlice = createSlice({
  name: 'messageAlert',
  initialState,
  reducers: {
    handleMessageAlertOpen: (state, action) => {
      console.log('handleMessageAlertOpen action ', action)
      state.open = true
      state.type = action.payload?.type
      state.message = action.payload?.message
      state.callback = action.payload?.callback
    },
    handleMessageAlertClose: (state) => {
      state.open = false
    }
  }
})

export const { handleMessageAlertOpen, handleMessageAlertClose } = RootMessageAlertSlice.actions

export default RootMessageAlertSlice.reducer